import {useCallback, useEffect, useRef} from "react";
import {call, delay} from 'redux-saga/effects';

import {useSagaCallback} from "../utils/sagas";
import {useRecaptcha} from "../modals/recaptcha";
import CancelTokenSource from "../utils/cancel";
import {apiPostWithCaptcha} from './client';

export function* createPost(data, recaptcha) {
    const url = `/api/v2/action/create_post`;
    const result = yield call(apiPostWithCaptcha, url, data, recaptcha);
    yield delay(1000);
    return result;
}

export const useCreatePost = (feedbackCh) => {
    const recaptcha = useRecaptcha();
    const cancelSourceRef = useRef(null);
    if (!cancelSourceRef.current) {
        cancelSourceRef.current = new CancelTokenSource();
    }
    useEffect(() => {
        return () => cancelSourceRef.current.cancel();
    }, [cancelSourceRef]);
    return useSagaCallback(feedbackCh, useCallback(function* (post) {
        return yield call(createPost, post, recaptcha);
    }, [recaptcha]), cancelSourceRef.current.token);
};
